export const LEVELUPLOG_LIST_REQUEST = 'LEVELUPLOG_LIST_REQUEST';

export const LEVELUPLOG_LIST = 'LEVELUPLOG_LIST';

export const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT';

export const SET_LEVELUPLOG_PAGINATION = 'SET_LEVELUPLOG_PAGINATION';

export const LEVELUPLOG_PAGE_RESET = 'LEVELUPLOG_PAGE_RESET';
